import React, { FC } from 'react';

import { styled } from '@mui/material';

import CheckIcon from '~/assets/icons/CheckIcon';
import TestIconBold from '~/assets/icons/TestIconBold';
import UnionIcon from '~/assets/icons/UnionIcon';
import { LightTooltip } from '~/components/UI/LightTooltip/LightTooltip';
import { PATHWAY_STATUSES } from '~/pages/const';

interface PathwayStatusProps {
  status: PATHWAY_STATUSES;
  className?: string;
  tooltip: any;
}

const PathwayStatus: FC<PathwayStatusProps> = ({ className, status, tooltip }) => {
  let icon;

  if (status === PATHWAY_STATUSES.NOT_WATCHED) {
    return null;
  }

  if (status === PATHWAY_STATUSES.STARTED) {
    icon = (
      <Circle>
        <UnionIcon />
      </Circle>
    );
  }

  if (status === PATHWAY_STATUSES.WATCHED) {
    icon = (
      <CirclePink>
        <StyledTest />
      </CirclePink>
    );
  }

  if (status === PATHWAY_STATUSES.COMPLETED) {
    icon = (
      <CircleGreen>
        <StyledCheck />
      </CircleGreen>
    );
  }

  return (
    <Wrapper className={className}>
      <LightTooltip placement="top" title={tooltip}>
        {icon}
      </LightTooltip>
    </Wrapper>
  );
};

export default PathwayStatus;

const Circle = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;
const CirclePink = styled(Circle)`
  background: ${({ theme }) => theme.palette.common.pink};
`;
const CircleGreen = styled(Circle)`
  background: ${({ theme }) => theme.palette.common.green};
`;
const Wrapper = styled('div')`
  width: 28px;
  height: 28px;
  cursor: pointer;
`;
const StyledTest = styled(TestIconBold)`
  width: 16px;
  height: 16px;

  & path {
    fill: ${({ theme }) => theme.palette.common.blueDark};
  }
`;
const StyledCheck = styled(CheckIcon)`
  width: 14px;
  height: 14px;
  color: ${({ theme }) => theme.palette.common.blueDark};

  & polyline {
    stroke-width: 3px;
  }
`;
